import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "cookie-consent-v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Small delay so it doesn't feel intrusive on first paint
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    if (window.__initPostHog) window.__initPostHog();
    setVisible(false);
  };
  const decline = () => {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, x: "-50%", opacity: 0 }}
          animate={{ y: 0, x: "-50%", opacity: 1 }}
          exit={{ y: 100, x: "-50%", opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-6 left-1/2 z-[60] w-[calc(100%-2rem)] max-w-[640px] bg-background/95 backdrop-blur-xl border border-border rounded-3xl shadow-[0_20px_60px_rgb(42,54,46,0.15)] p-5 sm:p-6"
        >
          <div className="flex items-start gap-4">
            <div className="hidden sm:flex w-10 h-10 shrink-0 rounded-full bg-primary/10 items-center justify-center text-primary">
              <Cookie size={18} strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <p className="font-body text-sm text-foreground leading-relaxed">
                Χρησιμοποιούμε <strong className="font-medium">απαραίτητα cookies</strong> για
                τη λειτουργία της σελίδας και <em>προαιρετικά</em> για ανώνυμη ανάλυση επισκεψιμότητας.{" "}
                <a
                  href="/politiki-aporritou"
                  data-testid="cookie-privacy-link"
                  className="underline underline-offset-2 hover:text-foreground/70"
                >
                  Πολιτική Απορρήτου
                </a>
              </p>
              <div className="mt-4 flex flex-col sm:flex-row gap-2">
                <button
                  onClick={accept}
                  data-testid="cookie-accept"
                  className="rounded-full bg-foreground text-background px-5 py-2.5 text-xs font-body font-medium hover:bg-foreground/85 transition-all"
                >
                  Αποδοχή όλων
                </button>
                <button
                  onClick={decline}
                  data-testid="cookie-decline"
                  className="rounded-full border border-border bg-transparent text-foreground/80 hover:bg-card px-5 py-2.5 text-xs font-body transition-all"
                >
                  Μόνο απαραίτητα
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
